module.exports = ".flat {\n  border-radius: 0; }\n\n.disabled {\n  pointer-events: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/toggleSwitch/toggleSwitch.component.scss
// module id = ./src/app/components/common/toggleSwitch/toggleSwitch.component.scss
// module chunks = main